<template>
  <span
    class="cheatsheet-toggle presentation-bottom-menu-hover hover-item"
    v-tooltip="tooltipContent"
    @click="toggleClick(inputMethods.MOUSE)"
  >
    <aha-icon
      name="k-button"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    ></aha-icon>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import EventBus from '@/eventBus'
import { INPUT_METHODS } from '@/constant/inputMethods.constants'
import { isFocusingOnAnInput } from '@/utils/dom.utils'
import { KEYCODES } from '@/constant/keycode.constant'

export default {
  data() {
    return {
      inputMethods: INPUT_METHODS,
    }
  },
  computed: {
    ...mapGetters(['isPresenting']),
    ...mapGetters('presentationHotKeyModule', ['seenCheatsheet']),
    tooltipContent() {
      return {
        content: this.$i18nPresenter.t('Keyboard shortcuts (K)'),
      }
    },
  },
  mounted() {
    this.registerHotkey()
  },
  destroyed() {
    this.unregisterHotkey()
  },
  methods: {
    registerHotkey() {
      EventBus.$on('onKeyboard', this.handleHotkey)
    },
    unregisterHotkey() {
      EventBus.$off('onKeyboard', this.handleHotkey)
    },
    toggleClick(method) {
      this.$emit('toggle-click', method)
    },
    handleHotkey(e) {
      if (e.keyCode !== KEYCODES.K) return
      if (!this.isPresenting) return
      if (isFocusingOnAnInput()) return
      this.toggleClick(INPUT_METHODS.KEYBOARD)
    },
  },
}
</script>

<style lang="scss" scoped>
.cheatsheet-toggle {
    display: inline-flex;
    flex-direction: column;
    align-items: center;

    &.hover-item::after {
        left: -8px;
        top: -8px;
    }
}
</style>
